var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "close-coupon" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "优惠券关闭",
            visible: _vm.dialogVisible,
            width: "50%",
            "destory-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c("el-alert", {
            staticStyle: { "margin-bottom": "20px" },
            attrs: {
              title: "关闭后不能恢复，请谨慎操作",
              type: "warning",
              "show-icon": "",
              closable: false,
            },
          }),
          _vm._v(" "),
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "异常关闭原因", prop: "closeReason" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "请输入内容",
                    },
                    model: {
                      value: _vm.form.closeReason,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "closeReason", $$v)
                      },
                      expression: "form.closeReason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "deager", loading: _vm.loading },
                  on: { click: _vm.submit },
                },
                [_vm._v("关闭")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取 消")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }